import CustomNavLink from "@/components/CustomLink/CustomNavLink";

interface CategoryMapping {
  category?: string;
  categorySlug?: string;
  subCategory?: string;
  subCategorySlug?: string;
}

const CategoryChips = ({ mappings }: { mappings?: CategoryMapping[] }) => {
  if (!Array.isArray(mappings) || mappings.length === 0) return null;

  // Drop incomplete entries defensively — every chip needs a category +
  // slug to navigate to and a subCategory to filter by.
  const valid = mappings.filter(
    (m) => m?.category && m?.categorySlug && m?.subCategory
  );
  if (valid.length === 0) return null;

  // Deduplicate by (categorySlug, subCategory) in case the backend ever
  // emits the same pairing twice.
  const seen = new Set<string>();
  const unique = valid.filter((m) => {
    const key = `${m.categorySlug}::${m.subCategory}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  return (
    <div className="flex flex-wrap gap-2">
      {unique.map((m, i) => (
        <CustomNavLink
          key={`${m.categorySlug}-${m.subCategory}-${i}`}
          href={`category/${m.categorySlug}?category=${encodeURIComponent(
            m.subCategory!
          )}`}
          className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 hover:bg-gray-200 text-sm text-own-black no-underline transition-colors"
        >
          <span>{m.category}</span>
          <span className="mx-1">{">"}</span>
          <span>{m.subCategory}</span>
        </CustomNavLink>
      ))}
    </div>
  );
};

export default CategoryChips;
